module.exports = __webpack_public_path__ + "img/Weapon_72.37e32505.png";